import React, { useEffect, useRef } from "react";
import { loadTinyMCEScript } from "./LoadTinyMCEScript";

interface BeelditWYSIWYGInputProps {
  value: string;
  onChange: (content: string) => void;
}

declare global {
  interface Window {
    tinymce: any;
  }
}

const BeelditWYSIWYGInput: React.FC<BeelditWYSIWYGInputProps> = ({
  value,
  onChange,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const editorIdRef = useRef(
    "beeldit-editor-" + Math.random().toString(36).substring(2, 15)
  );
  const editorId = editorIdRef.current;

  useEffect(() => {
    let isMounted = true;
    loadTinyMCEScript()
      .then(() => {
        if (!isMounted || !window.tinymce) return;
        window.tinymce.init({
          selector: `#${editorId}`,
          height: 300,
          menubar: false,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "code",
            "help",
            "wordcount",
          ],
          toolbar:
            "undo redo | blocks fontfamily fontsize | code | formatselect " +
            "bold italic backcolor | alignleft aligncenter " +
            "alignright alignjustify | table | bullist numlist outdent indent | " +
            "removeformat | fontsizeselect fontselect | insertdatetime | media | help",
            setup: (editor: any) => {
              editor.on("init",    () => editor.setContent(value || ""));
              editor.on("change keyup", () => onChange(editor.getContent()));
            }
        });
      })
      .catch(console.error);

    return () => {
      isMounted = false;
      // destruyo el editor asociado al ID
      window.tinymce?.remove(`#${editorId}`);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // solo al montar

  return <textarea id={editorId} ref={textareaRef} />;
};

export default BeelditWYSIWYGInput;
